"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EffluentPond = void 0;
const Pond_1 = require("./Pond");
const typeName = 'EffluentPond';
class EffluentPond extends Pond_1.Pond {
    constructor(ob) {
        super({ ...ob, type: typeName });
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
        };
    }
}
exports.EffluentPond = EffluentPond;
